import React from 'react'
import Link from 'gatsby-link';

const FooterMenu = () => (
  <nav>
    <ul
      css={{
        listStyle: 'none',
        margin: 0,
        padding: '60px 20px 0',

        li: {
          display: 'inline-block',
          margin: '0 10px 0 0',
        },

        a: {
          border: 0,
          color: '#333',
          fontSize: '.8rem',
          fontWeight: 600,
          letterSpacing: 1,
          textDecoration: 'underline',
        }
      }}
    >
      <li><Link to={'privacy'}>Privacy Policy</Link></li>
      <li><Link to={'terms'}>Terms</Link></li>
    </ul>
  </nav>
)

export default FooterMenu



// WEBPACK FOOTER //
// ./src/components/FooterMenu.js